'user strict';

import { createSelector } from 'reselect';

export const getLocation = ({ app }) => app.location;
export const getClientWidth = ({ app }) => app.clientWidth;
export const getUrlParams = ({ app }) => app.urlParams;
export const getPageUsername = ({ app }) => app.urlParams.username;
export const getPageDate = ({ app }) => app.urlParams.date;
export const getPageJobId = ({ app }) => app.urlParams.jobId;
export const getActionMode = ({ app }) => app.actionMode;
export const getPage = ({ app }) => app.page;
export const getResponsive = ({ app }) => app.responsive;
export const isMobile = ({ app }) => !app.responsive.md;
export const getPageContext = ({ app }) => app.pageContext;
export const isPageLoaded = ({ app }) => !!app.pageLoaded[ app.location.pathname ];
export const getSlug = ({ app }) => app.location.pathname.split('/').pop();
export const getPageUrl = ({ app }) => app.location.pathname;
export const getPageId = ({ app }) => app.pageId;
export const isRouterInProgress = ({ app }) => app.routerInProgress;
export const getModalStates = ({ app }) => app.modals;
export const isModalOpen = ({ app }, { modalId }) => app.modals[ modalId ];
export const isMenuOpen = ({ app }) => app.isMenuOpen;
export const getModalProps = ({ app }) => app.modalProps;
export const getWeekNav = ({ app }) => app.nav.week;
export const getDayNav = ({ app }) => app.nav.day;
export const isUsersLoaded = ({ app }) => app.usersLoaded;
